import React from 'react';
import { SECTIONS, countInSection, POSTS } from './content';

const STATION = [
  { label: 'Callsign',    value: 'NK4I'   },
  { label: 'Grid square', value: 'EM85au' },
  { label: 'ITU zone',    value: '8'      },
  { label: 'CQ zone',     value: '4'      },
];

export default function AboutPage({ navigate }) {
  const dated = POSTS.filter((p) => p.date);
  const earliest = dated.length ? dated[dated.length - 1].date.slice(0, 4) : null;

  return (
    <div className="page page-narrow">
      <p className="section-label">Welcome to all things NK4I</p>
      <h1 className="section-title">About the Station</h1>
      <div className="section-divider" />

      <div className="article-content">
        <p>
          This site is a long-running notebook for the NK4I station — write-ups
          of gear that came through the shack, logs from portable activations
          and contests, and a fair number of projects that have nothing to do
          with radio at all.
        </p>
        <p>
          It began life on Joomla, spent years on Grav, and now lives here as a
          static site. {earliest ? `The archive reaches back to ${earliest}.` : ''}
        </p>
      </div>

      <dl className="station-grid">
        {STATION.map(({ label, value }) => (
          <div key={label} className="station-item glass-card">
            <dt className="station-label">{label}</dt>
            <dd className="station-value">{value}</dd>
          </div>
        ))}
      </dl>

      <h2 className="section-subtitle">What’s here</h2>
      <ul className="about-sections">
        {SECTIONS.map((section) => (
          <li key={section.key}>
            <button className="link-btn" onClick={() => navigate(section.key)}>
              {section.label}
            </button>
            <span className="about-count">
              {countInSection(section.key)} entries
            </span>
            <p className="about-blurb">{section.blurb}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
